const RequestStatus = Object.freeze({
  Idle: 'idle',
  Loading: 'loading',
  Succeeded: 'succeeded',
  Failed: 'failed'
});

export default RequestStatus;